import React from 'react';
//fontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//style
import styles from 'src/asset/scss/style/user.mypage.module.scss';
//select
import SelectSearch from 'react-select-search';
import 'src/asset/scss/plugin/select.scss';
//bottomSheet
import { BottomSheet } from 'react-spring-bottom-sheet';
//import 'react-spring-bottom-sheet/dist/style.css';
import 'src/asset/scss/plugin/bottomsheet/style.scss';
import 'src/asset/scss/plugin/bottomsheet/bottomsheet.scss';
//store
import usePartnerStore from 'src/webapp/stores/partner.store';
//hook
import useMypageHook from 'src/webapp/hooks/mypage/mypage.hook';

export default function _bsInfoUpdate(props) {
	const { isOpen } = props;//props
	const { info } = usePartnerStore();
	const { setMechanicOptionHandler, mechanicList//정비인원수 셋팅
		, isDisabled, onValidHandler//회원정보수정 버튼활성화여부
        , inputRef, partnerUpdateAPI//회원정보수정
	} = useMypageHook();

	/* =============== 회원정보변경 =============== */
	const onUpdateHandler = async() => {
		const result = await partnerUpdateAPI();
		if(result) { props.onDismiss(false); }
	}
	/* =============== 회원정보변경 =============== */

	return (
		<BottomSheet open={isOpen} onDismiss={(e) => { props.onDismiss(false) }}
			className={'bottomsheetContainer'}
			onSpringStart={async (event) => {
				if(event.type === 'OPEN') { setMechanicOptionHandler(); }
			}}
			header={
				<>
				<button className={'bottomsheetDissmissButton'} onClick={(e) => props.onDismiss(false)}><FontAwesomeIcon icon="fa-light fa-xmark" /></button>
                <div style={{marginBottom:'2.5rem'}} className={'bottomsheetHeaderContainer'}>
					<h1>프로필 수정하기</h1>
                </div>
				</>
            }
            footer={
				<div style={{marginBottom:'1.25rem'}} className={styles.bottomsheetPartnerUpdateBtnArea}>
					<button onClick={(e) => onUpdateHandler()} disabled={isDisabled} className={styles.btnSubmit}>확인</button>
					<button onClick={(e) => props.onDismiss(false)} className={styles.btnCancel}>취소</button>
                </div>
            }
			snapPoints={({ maxHeight }) => maxHeight}
            skipInitialTransition={false} scrollLocking={false} expandOnContentDrag={true}>
			<div className={styles.bottomsheetPartnerUpdateContainer}>
				<div className={styles.imgContainer}>
					<div className={styles.imgArea}><img src={`${process.env.REACT_APP_IMAGE_URL + info.IMG_SRC}`} alt={info.PARTNER_NAME} /></div>
				</div>
				<div className={styles.inputContainer}>
					<div>
						<label>정비소명</label>
						<input ref={el => (inputRef.current[0] = el)}
                            onChange={(e) => onValidHandler()}
                            defaultValue={info.PARTNER_NAME}
                            type='text' placeholder={`정비소명을 입력해주세요`} />
					</div>
					<div>
						<label>정비인원</label>
						<div className={['selectSearch', 'lightSelectContainer'].join(' ')}>
							<SelectSearch ref={el => (inputRef.current[1] = el)}
								onChange={(e) => {(inputRef.current[1].value = e); onValidHandler()}}
								options={mechanicList} defaultValue={info.MECHANIC} />
						</div>
					</div>
					<div>
						<label>소개글</label>
						<textarea ref={el => (inputRef.current[2] = el)}
                            onChange={(e) => onValidHandler()}
                            defaultValue={info.SUMMARY} 
                            placeholder={`소개글을 입력해주세요`} maxLength={500}></textarea>
					</div>
				</div>
			</div>
		</BottomSheet>
	)
}